import React from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import {
  Box,
  Container,
  Grid,
  Typography,
  makeStyles,
  Button
} from '@material-ui/core';
import { useHistory } from 'react-router';
import LandingPageImage from "src/assets/images/landing-page.png"

const useStyles = makeStyles(theme => ({
  root: {
    backgroundColor: theme.palette.background.dark,
    paddingTop: 200,
    paddingBottom: 200,
    [theme.breakpoints.down('md')]: {
      paddingTop: 60,
      paddingBottom: 60
    }
  },
  image: {
    perspectiveOrigin: 'left center',
    transformStyle: 'preserve-3d',
    perspective: 1500,
    '& > img': {
      maxWidth: '100%',
      height: 'auto',
      transform: 'rotateY(-35deg) rotateX(15deg)',
      backfaceVisibility: 'hidden',
      boxShadow: theme.shadows[16]
    }
  },
  shape: {
    position: 'absolute',
    top: 0,
    left: 0,
    '& > img': {
      maxWidth: '100%',
      height: 'auto'
    }
  }
}));

function Hero({ className, ...rest }) {
  const classes = useStyles();
  const history = useHistory();
  return (
    <div className={clsx(classes.root, className)} {...rest}>
      <Container maxWidth="lg">
        <Grid container spacing={3}>
          <Grid item xs={12} md={5}>
            <Box
              display="flex"
              flexDirection="column"
              justifyContent="center"
              height="100%"
            >
              <Typography variant="overline" color="textSecondary">
                Introducing
              </Typography>
              <Typography variant="h1" color="textPrimary">
                Building Permit and Certificate of Occupancy System
              </Typography>
              <Box mt={3}>
                <Typography variant="body1" color="textSecondary">
                  For builders and developers, the Building Permit and Certificate of Occupancy System (BPCOS) streamlines permit applications, compliance verification, inspections, and occupancy certification, reducing processing time while ensuring compliance with the National Building Code.
                </Typography> 
              </Box>
              <Box mt={3}>
                <Grid container spacing={3}>
                  <Grid item> 
                    <Box mt={4} align="center">
                      <Button
                        variant="contained"
                        color="primary"
                        // onClick={() => history.push('/guides')}
                        onClick = { () => {
                          window.open(`${process.env.REACT_APP_S3_URL}/video-guide/bpcos-guide.mp4`, '_blank');
                        }}
                      >
                        Paano kumuha ng building permit
                      </Button>
                    </Box>
                  </Grid>
                </Grid>
              </Box>
            </Box>
          </Grid>
          <Grid item xs={12} md={7}>
            <Box position="relative">
              <div className={classes.shape}>
                <img alt="Shapes" src="/static/home/shapes.svg" />
              </div>
              <div className={classes.image}>
                <img alt="Presentation" src={LandingPageImage} />
              </div>
            </Box>
          </Grid>
        </Grid>
      </Container>
    </div>
  );
}

Hero.propTypes = {
  className: PropTypes.string
};

export default Hero;
